export default __webpack_public_path__ + "static/media/olood_gang1.009ac6b8.JPG";